import {
  generatePath,
  useMatch,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@jana-technology/platform-ui";

import {
  RISK_ROUTE_CHARTS_MITIGATION,
  RISK_ROUTE_CHARTS_OVERALL,
} from "constants/routing";
import { useGlobalFiltersContext } from "contexts/filters";

import SidebarComponentHeading from "./ComponentHeading";
import SidebarSpacer from "./Spacer";

export const RiskMitigationSelect = () => {
  const {
    wellIdNameParam,
    appliedRiskMitigationId,
    setAppliedRiskMitigationId,
    riskMitigationQueryResult,
  } = useGlobalFiltersContext();

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const { riskMitigations } = riskMitigationQueryResult.data ?? {};

  const riskMitigationRouteMatch = useMatch({
    path: RISK_ROUTE_CHARTS_MITIGATION,
    end: false,
  });

  return (
    <SidebarSpacer>
      <SidebarComponentHeading>Mitigation Scenario:</SidebarComponentHeading>
      {riskMitigations && (
        <Select
          value={String(appliedRiskMitigationId)}
          onValueChange={(value) => {
            const riskMitigationTypeId = Number(value);

            setAppliedRiskMitigationId(riskMitigationTypeId);

            if (riskMitigationTypeId && !riskMitigationRouteMatch) {
              // can only show mitigation risk charts when a risk mitigation is applied
              navigate({
                pathname: generatePath(
                  `${RISK_ROUTE_CHARTS_MITIGATION}/${wellIdNameParam}`,
                ),
                search: searchParams.toString(),
              });
            } else if (riskMitigationTypeId === 0) {
              navigate({
                pathname: generatePath(
                  `${RISK_ROUTE_CHARTS_OVERALL}/${wellIdNameParam}`,
                ),
                search: searchParams.toString(),
              });
            }
          }}
        >
          <SelectTrigger className="w-full" id="risk-mitigation-select">
            <SelectValue placeholder="Select one" />
          </SelectTrigger>
          <SelectContent>
            {riskMitigations.filter(Boolean).map((mitigation) => (
              <SelectItem key={mitigation?.id} value={String(mitigation?.id)}>
                {mitigation?.value}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    </SidebarSpacer>
  );
};

export default RiskMitigationSelect;
